import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import DeleteConfirmation from "../deleteConfirmation";
import Table from "./../Theme/Table.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Add from "./Add";
import Edit from "./Edit";
import Badge from "@mui/material/Badge";
import "../modal.css";
import Spinner from "../Spinner";
import { useLocation } from "react-router";
import { useContext } from "react";
import { RoleContext } from "../RoleContext";
import VehicleForm from "./VehicleForm.js";
import ActionButtons from "./VeiclesListActionButtons.js";


import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import { 
  Edit as EditIcon, 
  Delete as DeleteIcon,
  Visibility as VisibilityIcon
} from '@mui/icons-material';
import {  useNavigate } from 'react-router-dom';


const VehiclesList = () => {
  const roleData = useContext(RoleContext);
  var role = JSON.parse(roleData);
  const location = useLocation();
  const [vehicles, setVehicles] = useState([]);
  const [id, setId] = useState(null);
  const [data, setData] = useState(null);
  let [loading, setLoading] = useState(true);


  const navigate = useNavigate();


  const getVehicles = async () => {
    const response = await axios
      .get("vehicles/")
      .then((res) => {
        setVehicles(res.data);
        setLoading(false);
        //notify()
      })
      .catch((err) => {
        notifyError();
      });
  };

  const showAddModal = () => {
    setDisplayAddModal(true);
  };

  // Hide the modal
  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const [deleteMessage, setDeleteMessage] = useState(null);
  const [displayAddModal, setDisplayAddModal] = useState(false);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const showDeleteModal = (id, name) => {
    setId(id);
    setDeleteMessage("Are you sure you want to delete this vehicle");
    setDisplayConfirmationModal(true);
  };
  // Hide add modal
  const hideAddModal = () => {
    setDisplayAddModal(false);
  };
  const submitDelete = (id) => {
    console.log(id);
    deleteVehicle(id);
    getVehicles();
    setDisplayConfirmationModal(false);
    // getVehicles();
  };
  const deleteVehicle = async (id) => {
    const response = await axios.delete("/vehicle/" + id, {
      data: { id: id },
    });
    getVehicles();
  };

  const showEditModal = (id) => {
    setId(id);

    axios.get("/vehicle/" + id, {}).then((res) => {
      setData(res.data.vehicle);
      setDisplayEditModal(true);
    });
  };
  const [displayEditModal, setDisplayEditModal] = useState(false);
  const hideEditModal = () => {
    setDisplayEditModal(false);
  };

  const edit = "vehicle";
  const detail = "viewVehicle";

  const notify = () =>
    toast.success("Vehicles list loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  useEffect(() => {
    getVehicles();
  }, [location.key]);
  
  
  
const columns = React.useMemo(
  () => [
    {
      Header: "Vehicle Info",
      columns: [
        {
          Header: "ID",
          accessor: "id",
        },
        {
          Header: "Plate Number",
          accessor: "plateNumber",
        },
        {
          Header: "Model",
          accessor: "model",
        },
        {
          Header: "Color",
          accessor: "color",
        },
      ],
    },
    {
      Header: "Driver Info",
      columns: [
        {
          Header: "Drivers",
          id: "driverNames",
          accessor: (row) => ((row.drivers || [])
            .map(d => `${d.firstName || ''}${d.lastName ? ' ' + d.lastName : ''}${d.phoneNumber ? ' (' + d.phoneNumber + ')' : ''}`)
            .join(', ')
            .toLowerCase()),
          Cell: (row) => {
            const drivers = row.cell.row.original.drivers || [];
            if (!drivers.length) {
              return <span style={{ color: '#6b7280' }}>No driver</span>;
            }
            const maxVisible = 2;
            const chips = drivers.slice(0, maxVisible).map((d, idx) => (
              <Chip
                key={d.id || idx}
                label={`${d.firstName || ''}${d.lastName ? ' ' + d.lastName : ''}`}
                size="small"
                color="primary"
                variant="outlined"
                sx={{ mr: 0.5, mb: 0.5 }}
              />
            ));
            const extra = drivers.length - maxVisible;
            return (
              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                {chips}
                {extra > 0 && (
                  <Tooltip
                    title={drivers
                      .slice(maxVisible)
                      .map(d => `${d.firstName || ''}${d.lastName ? ' ' + d.lastName : ''}${d.phoneNumber ? ' (' + d.phoneNumber + ')' : ''}`)
                      .join(', ')}
                  >
                    <Chip
                      label={`+${extra} more`}
                      size="small"
                      color="secondary"
                      sx={{ mr: 0.5, mb: 0.5 }}
                    />
                  </Tooltip>
                )}
              </div>
            );
          },
          filter: 'includes',
        },
         {
          Header: "Ambulance Company",
          accessor: "company.company_name",
          Cell: ({ value }) => value ? value : <span style={{ color: 'gray' }}>N/A</span>,
        },
         {
          Header: "Vehicle Type",
          accessor: "vehicleType.typeName",
          Cell: ({ value }) => value ? value : <span style={{ color: 'gray' }}>N/A</span>,
        },
        {
          Header: "Status",
          accessor: "status",
          disableFilters: true,
          Cell: (row) => {
            const status = row.cell.row.original.status || "Active";
            return (
              <Chip 
                label={status} 
                color={status === "Active" ? "success" : "warning"}
                variant="filled"
                sx={{
                  fontWeight: 'bold',
                  borderRadius: '8px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  boxShadow: status === "Active" 
                    ? '0 2px 4px rgba(0,255,0,0.2)' 
                    : '0 2px 4px rgba(255,165,0,0.2)'
                }}
              />
            );
          },
        },
        {
          Header: "Action",
          accessor: "action",
          disableFilters: true,
          Cell: (row) => (
            <div style={{ 
              display: "flex", 
              gap: "15px", 
              alignItems: 'center' 
            }}>
              {role.filter(e => e.perm_name === "edit_vehicle").length > 0 && (
                <Tooltip title="Edit Vehicle">
                  <span>
                    <EditIcon 
                      color="primary" 
                      sx={{ 
                        cursor: 'pointer',
                        transition: 'transform 0.2s',
                        '&:hover': {
                          transform: 'scale(1.2)',
                          color: '#1e40af'
                        }
                      }}
                      onClick={() => showEditModal(row.cell.row.original.id)}
                    />
                  </span>
                </Tooltip>
              )}
              
              {role.filter(e => e.perm_name === "view_vehicle").length > 0 && (
                <Tooltip title="View Vehicle Details">
                  <span>
                    <VisibilityIcon 
                      color="success" 
                      sx={{ 
                        cursor: 'pointer',
                        transition: 'transform 0.2s',
                        '&:hover': {
                          transform: 'scale(1.2)',
                          color: '#16a34a'
                        }
                      }}
                      onClick={() => navigate(`/${detail}/${row.cell.row.original.id}`)}
                    />
                  </span>
                </Tooltip>
              )}
              
              {role.filter(e => e.perm_name === "delete_vehicle").length > 0 && (
                <Tooltip title="Delete Vehicle">
                  <span>
                    <DeleteIcon 
                      color="error" 
                      sx={{ 
                        cursor: 'pointer',
                        transition: 'transform 0.2s',
                        '&:hover': {
                          transform: 'scale(1.2)',
                          color: '#ff0000'
                        }
                      }}
                      onClick={() => showDeleteModal(row.cell.row.original.id)}
                    />
                  </span>
                </Tooltip>
              )}
            </div>
          ),
        },
      ],
    }
  ],
  []
);



  return (
    <div className="content-wrappers" style={{ marginTop: '-40px' }}>
    <div className="content-wrappers">
      <ToastContainer />
      <br />
      <br />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                
                <ActionButtons role={role} showAddModal={showAddModal} />

                <div className="card-body">
                  {loading && (
                    <div>
                      <Spinner />
                    </div>
                  )}
                  {!loading && (
                    <Table
                      columns={columns}
                      data={vehicles}
                      edit={edit}
                      detail={detail}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={submitDelete}
        hideModal={hideConfirmationModal}
        id={id}
        message={deleteMessage}
      />
      {/* <Add
        showModal={displayAddModal}
        hideModal={hideAddModal}
        getVehicles={getVehicles}
      /> */}

      <VehicleForm
        mode={"add"}
        showModal={displayAddModal}
        hideModal={hideAddModal}
        onSuccess={getVehicles}
      />

      
      {/* {displayEditModal == true && (
        <Edit
          id={id}
          data={data}
          showModal={displayEditModal}
          hideModal={hideEditModal}
          getVehicles={getVehicles}
        />
      )} */}

      {
        displayEditModal == true && (
          <VehicleForm
            mode={"edit"}
            showModal={displayEditModal}
            initialData={data}
            hideModal={hideEditModal}
            onSuccess={getVehicles}
          />
        )
      }
      </div>
    </div>
  );
};

export default VehiclesList;